import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 5);

  return (
    <section className="py-14 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选内容
            </h2>
            <p className="text-foreground-600 text-sm">
              编辑精选的优质文章，每一篇都值得收藏
            </p>
          </div>
          <Link
            to="/category/recommended"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/recommended"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部精选内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}